export enum ModalSize {
  Message = '400px',
  Error = '500px',
  Warning = '600px',
  Info = '700px',
  Form = '900px',
  BigInfo = '1092px',
  Auto = 'auto',
}
